<template>
  <div class="checkout">
    <el-row class="container mb-100">
      <el-col :span="layoutBreakpoint.isMobile ? 24 : 15" class="text-left">
        <h2 class="title text-uppercase text-left pt-60">
          {{ $t("checkout.commander") }}
        </h2>
        <ShoppingCartSummary
          :shoppingCart="shoppingCart"
          :cartListProduct="cartListProduct"
          :isCheckOut="true"
          :cartSummaryData = "cartSummaryData"
          @emit-checkout-total="getTotal"
          v-if="layoutBreakpoint.isMobile && showCartcaculate && isCreated"
          class="mt-60"
        />
        <h6 class="mt-20" :style="step1">{{ $t("checkout.step1") }}</h6>
        <h3 class="text-left checkout-form" :style="heading1">
          {{ $t("checkout.informationPersonnelle") }}
          <el-link
            v-if="profileEditLink"
            type="primary"
            :underline="true"
            @click="
              (informationPersonnelle = true),
                (userDetailsForm = true),
                (profileEditLink = false),
                (enablepaymentSection = false),
                (deliveryType = false),
                (userAddressForm = true),
                updateStyle()
            "
          >
            {{ $t("users.account.editBtn") }}
          </el-link>
        </h3>
        <div class="personnal-infos-box mt-18 text-left" v-if="profileEditLink">
          <span v-if="user.firstName">{{ user.firstName }} {{ user.lastName }}</span><br />
          <span v-if="user.email">{{ user.email }}</span>
          <span v-if="user.phone"><br />{{ user.phone }}</span>
        </div>
        <div class="user-details-form" v-if="informationPersonnelle">
          <div class="user-address" v-if="userAddressForm">
            <DeliveryAddressComponent
              :shippingAddress="setShippingAddress"
              :billingAddress="setBillingAddress"
              :user-detail="userDetail"
              :checkOut="true"
              :cta-submit-text="$t('checkout.nextStep')"
              :countries="countries"
              @emit-update-details="informationForm"
            />
          </div>
        </div>
        <h6 class="mt-20" :style="step2">{{ $t("checkout.step2") }}</h6>
        <h3 class="text-left mt-10 checkout-form" :style="heading2">
          {{ $t("checkout.informationDelivery") }}
        </h3>
        <div v-if="deliveryType">
          <DeliveryType @emit-update-Delivery-Type="updateDeliveryType" :saq-branches="saqBranches" />
        </div>
        <h6 class="mt-20" :style="step3">{{ $t("checkout.step3") }}</h6>
        <h3 class="text-left mt-10 mb-20 checkout-form" :style="heading3">
          {{ $t("checkout.paymentInformation") }}
        </h3>
        <div
          class="text-left"
          v-if="
            !isPaymentVisible &&
            isPaymentEnabled &&
            !paymentError &&
            enablepaymentSection
          "
        >
          <!-- <el-button
            type="primary"
            style="height: 35px; width: 203px"
            @click="payNow"
          >
            {{ $t("checkout.nextStep") }}----
          </el-button> -->
        </div>
        <el-alert
          v-if="paymentError"
          :title="$t('checkout.errorMessage1')"
          :description="paymentError"
          type="error"
          :closable="false"
          :center="false"
        />
        <CheckoutStripe
          v-if="isCreated && Object.keys(calculationData).length"
          :load-checkout="isPaymentVisible"
          :trigger-confirm-payment="isPaymentConfirmed"
          :total="total"
          :shopping-cart-id="shoppingCartId"
          :calculationData="calculationData"
          :deliveryBranch="selectedDeliveryBranch"
          @stripe-load-end="enablePay"
          @enable-confirmation="enableConfirmation"
          @error="showError"
        />
      </el-col>
      <el-col :span="layoutBreakpoint.isMobile ? 0 : 9" class="pl-40 mt-125">
        <ShoppingCartSummary
          :shoppingCart="shoppingCart"
          :cartListProduct="cartListProduct"
          :cartSummaryData = "cartSummaryData"
          :isCheckOut="true"
          @emit-checkout-total="getTotal"
          v-if="!layoutBreakpoint.isMobile && showCartcaculate && isCreated"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";
import Store from "@/store";
import CheckoutStripe from "./components/checkout-stripe.vue";
import DeliveryType from "./components/delivery-type-form.vue";
import ShoppingCartSummary from "../shopping-cart/components/shopping-cart-summary.vue";
import userApi from "@/api/user";
import DeliveryAddressComponent from "./components/delivery-address-form.vue";
import countryApi from "@/api/country";
import checkoutApi from "@/api/checkout";
import goTo from "../../mixins/goTo";

import { mapState, mapGetters, mapActions } from "vuex";
import { get, isEmpty, map, find } from "@/utils/lodash";
import ShoppingCart from "@/api/shopping-cart";
import { reportError } from "@/utils/error-reporter";

export default {
  mixins: [goTo],
  components: {
    CheckoutStripe,
    ShoppingCartSummary,
    DeliveryAddressComponent,
    DeliveryType,
  },
  data() {
    return {
      isPaymentVisible: false,
      isPaymentEnabled: false,
      isPaymentConfirmed: false,
      paymentError: null,
      selectedDeliveryBranch: null,
      showCartcaculate: false,
      cartListProduct: {},
      userDetail: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
      },
      userRules: {
        firstName: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.firstName"),
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.lastName"),
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.email"),
          },
        ],
        phone: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.phone"),
          },
        ],
      },
      userDetailsForm: true,
      userAddressForm: false,
      informationPersonnelle: true,
      profileEditLink: false,
      deliveryType: false,
      enablepaymentSection: false,
      total: 0,
      shoppingCartId: null,
      Countries: [],
      step1: {},
      step2: {
        opacity: "0.5",
      },
      step3: {
        opacity: "0.5",
      },
      heading1: {},
      heading2: {
        opacity: "0.5",
      },
      heading3: {
        opacity: "0.5",
      },
      cartSummaryData: {},
      isCreated: false,
      saqBranches: [],
      calculationData: {},
      getCountrycode: localStorage.getItem('countryCode'),
    };
  },
  computed: {
    ...mapState("user", ["user", "userDetails"]),
    ...mapState("shoppingCart", ["shoppingCart"]),
    ...mapState("product", ["products"]),
    ...mapGetters("user", ["isLoggedIn"]),
    layoutBreakpoint() {
      return layoutUtils.layoutBreakpoint(this.$mq);
    },
    setBillingAddress() {
      const addresses = get(this.user, "billingAddress") || get(this.userDetails, "billingAddress");
      if (addresses == null) {
        return {
          street: null,
          postalCode: null,
          state: {
            name: null,
          },
          country: {
            id: null,
          },
          regions: null,
        };
      }
      return addresses;
    },
    setShippingAddress() {
      const addresses = get(this.user, "shippingAddress") || get(this.userDetails, "shippingAddress");
      if (addresses == null) {
        return {
          street: null,
          postalCode: null,
          state: {
            name: null,
          },
          country: {
            id: null,
          },
          regions: null,
        };
      }
      return addresses;
    },
  },
  async created() {
    const getId = JSON.parse(localStorage.getItem("user"));
    if (getId) {
      await this.getUserDetails({ customerId: getId?.id})
      this.setuserDetails();
    }    
    this.fetchCountries();
    // if (!getId) {
    //     this.goTo("/shopping-cart-empty");
    //     return;
    // }

    // Fetch the shopping cart and wait until it's loaded
    try {
      if (getId) {
        await this.fetchShoppingCart({
            id: getId?.id,
            idType: "id",
        });
      }
    } catch (error) {
        reportError("CHECKOUT_CART_FETCH_FAILED", {
          message: error && error.message,
          error,
        });
        // this.goTo("/shopping-cart-empty");
        return;
    }

    // This used to read the unsuffixed `cartProducts` key to merge a guest cart
    // into the server cart. That key is never written — the guest cart is stored
    // per market as `cartProducts<countryCode>` — so the merge loop never ran and
    // the only thing that did happen was fetchProductsByPuid({puids: []}), whose
    // empty result wiped the products this page renders its line items from.
    // Dropping the dead merge rather than re-pointing it at the suffixed key: the
    // server cart is already authoritative here (fetchShoppingCart above), so
    // re-adding those puids on every checkout mount would double the quantities.
    this.getCartCalculation();

    await this.fetchSaqBranches();
    await this.getProducts();
},
  mounted() {
    this.$root.$on("chanLang", () => {
      if(this.informationPersonnelle){
        this.informationPersonnelle = false;
        this.$nextTick(() => {
          this.informationPersonnelle = true;
        });
      }
    });
  },
  methods: {
    ...mapActions("user", ["updateUser", "getUserDetails"]),
    ...mapActions("shoppingCart", ["fetchShoppingCart", "updateShoppingCart", "addProductToShoppingCart"]),
    ...mapActions("product", ["fetchProductsByPuid"]),
    mapProducts(cartProducts) {
      const vm = this;
      if (!isEmpty(vm.products)) {
        const productsItems = map(cartProducts, (cartProduct) => {
          this.showCartcaculate = true;
          const product = find(vm.products, (p) => p.puid === cartProduct.puid);
          this.cartListProduct = vm.products;
          return {
            item: cartProduct,
            product,
          };
        });

        return productsItems;
      }
      return [];
    },
    payNow() {
      this.isPaymentVisible = true;
    },
    enablePay() {
      this.isPaymentEnabled = true;
    },
    enableConfirmation() {
      // Portaus now finalizes the SalesOrder via Stripe webhook on payment success,
      // so the explicit user-driven confirm step is redundant. Auto-trigger the
      // backend confirm and let the child finalize regardless of its result.
      this.isPaymentConfirmed = true;
    },
    showError(e) {
      this.isPaymentVisible = false;
      this.paymentError = e;
    },
    setuserDetails() {
      this.userDetail = this.user;
    },
    getProducts() {
      return this.mapProducts(
        get(this.shoppingCart, "products").filter((p) => p.puid != null)
      );
    },
    informationForm() {
      this.informationPersonnelle = false;
      this.profileEditLink = true;
      this.deliveryType = true;
      this.step1 = {
        opacity: "0.5",
      };
      this.step2 = {
        opacity: "1",
      };
      this.step3 = {
        opacity: "0.5",
      };
      this.heading1 = {
        opacity: "0.5",
      };
      this.heading2 = {
        opacity: "1",
      };
      this.heading3 = {
        opacity: "0.5",
      };
      this.updateUser();
      if(this.getCountrycode == 'ON'){
        this.updateDeliveryType();
      }
    },
    updateUserDetails(e) {
      e.preventDefault();
      const vm = this;
      this.$refs.userDetailsUpdate.validate().then((valid) => {
        if (valid) {
          if (!this.isLoggedIn && !localStorage.getItem('access-token')) {
            console.log('guestuser');
          }else{
            userApi
              .updateUser(this.user.id, {
                firstName: vm.userDetail.firstName,
                lastName: vm.userDetail.lastName,
                email: vm.userDetail.email,
              })
              .then((data) => {
                if (data) {
                  this.userEditDetailsBtn = true;
                  this.showDetailform = false;
                  this.userDetailsForm = false;
                  this.userAddressForm = true;
                } else {
                  vm.$emit("error", "cannot authenticate user");
                }
              })
              .catch((error) => {
                vm.$emit("error", error);
              });
          }
        }
      });
    },
    async updateDeliveryType(branch) {
      this.selectedDeliveryBranch = branch || null;
      this.deliveryType = false;
      this.enablepaymentSection = true;
      this.step1 = {
        opacity: "0.5",
      };
      this.step2 = {
        opacity: "0.5",
      };
      this.step3 = {
        opacity: "1",
      };
      this.heading1 = {
        opacity: "0.5",
      };
      this.heading2 = {
        opacity: "0.5",
      };
      this.heading3 = {
        opacity: "1",
      };
      await this.payNow();
    },
    getTotal(total = 0) {
      this.total = total;
    },
    fetchCountries() {
      Promise.all([countryApi.fetchCountries()]).then((result) => {
        this.countries = result[0];
        this.userAddressForm = true;
      });
    },
    updateStyle() {
      this.step1 = {
        opacity: "1",
      };
      this.step2 = {
        opacity: "0.5",
      };
      this.step3 = {
        opacity: "0.5",
      };
      this.heading1 = {
        opacity: "1",
      };
      this.heading2 = {
        opacity: "0.5",
      };
      this.heading3 = {
        opacity: "0.5",
      };
    },
    updateUser() {
        if (this.isLoggedIn) {
          userApi.findById(JSON.parse(localStorage.user).user.id).then((user) => {
          Store.dispatch("user/setUserProfile", user);
        }); 
        localStorage.setItem("isGuestUser", false);
      }else{
        localStorage.setItem("isGuestUser", true);
      }
    },
    getCartCalculation() {
      let cart; // declare outside the if-else so it's accessible afterward

      if (this.isLoggedIn) {
        const cartProducts = get(this.shoppingCart, "products");
        const productsItems = map(cartProducts, (cartProduct) => {
          let qty = cartProduct.quantity;
          return {
            product: { puid: cartProduct.puid },
            qty: qty,
          };
        });

        const customerId = get(this.user, "customer.id", '') || localStorage.getItem("x-cart");
        cart = {
          customer: { id: customerId },
          lines: productsItems,
        };

      } else {
        const getCode = localStorage.getItem("countryCode");
        const getLocalstorageProduct = JSON.parse(localStorage.getItem("cartProducts" + getCode) || "[]");

        const productsItems = map(getLocalstorageProduct, (cartProduct) => {
          return {
            product: { puid: cartProduct.puid },
            qty: cartProduct.quantity,
          };
        });

        const customerId = get(this.user, "customer.id", '') || localStorage.getItem("x-cart");
        cart = {
          customer: { id: customerId },
          lines: productsItems,
        };
      }
      
      if (!cart.lines || cart.lines.length === 0) {
        this.goTo("/shopping-cart-empty");
      }
      this.showCartcaculate = true;
      ShoppingCart
        .getCartCalculation(cart)
        .then((data) => {
          if (data) {
            this.calculationData = data;
            this.cartSummaryData = data;
            this.total = this.cartSummaryData.totalBillable
            this.isCreated = true;
          }
        })
        .catch(() => {
          // this.isLoading = false;
          this.goTo("/shopping-cart-empty");
        });     
    },
    fetchSaqBranches() {
      Promise.all([checkoutApi.fetchSaqBranches()]).then((result) => {
        this.saqBranches = result[0];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.title {
  color: $color-on-background;

  // sm -
  @media screen and (max-width: $media-md) {
    height: 32px;
  }
  // md +
  @media screen and (min-width: $media-md) {
    height: 46px;
  }

  .display-none {
    display: none !important;
  }
}
.checkout-form {
  font-family: 'Futura LT Book', 'Futura', sans-serif;
}
</style>
